import { useCallback, useState } from "react";

export default function useGeolocation() {
  const [pos, setPos] = useState(null); // { lat, lng, acc, timestamp }
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(() => {
    if (!navigator.geolocation) {
      setError("Geolocation is not supported");
      return Promise.resolve(null);
    }

    setLoading(true);
    setError(null);

    return new Promise((resolve) => {
      navigator.geolocation.getCurrentPosition(
        (p) => {
          const next = {
            lat: p.coords.latitude,
            lng: p.coords.longitude,
            acc: p.coords.accuracy,
            timestamp: p.timestamp || Date.now(),
          };
          setPos(next);
          setLoading(false);
          resolve(next);
        },
        (e) => {
          setLoading(false);
          setError(e?.message || "Failed to get location");
          resolve(null);
        },
        {
          enableHighAccuracy: true,
          timeout: 30000,  // 30 сек — достаточно для холодного старта GPS без интернета
          maximumAge: 0,   // всегда свежая позиция
        }
      );
    });
  }, []);

  return { pos, error, loading, refresh };
}
